import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConstructorComponent} from './constructor.component';
import {RouterModule} from '@angular/router';
import {AlertModule} from '../shared/components/alert/alert.module';
import {InputModule} from '../shared/components/input/input.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {OptionsListModule} from '../shared/components/options-list/options-list.module';
import {DropdownModule} from '../shared/components/dropdown/dropdown.module';
import {CheckboxModule} from '../shared/components/checkbox/checkbox.module';
import {BadgeModule} from '../shared/components/badge/badge.module';
import {SwitcherModule} from '../shared/components/switcher/switcher.module';
import {DialogModule} from '../shared/components/dialog/dialog.module';
import {PinInputModule} from '../shared/components/pin-input/pin-input.module';
import {MenuModule} from '../shared/components/menu/menu.module';
import {SearchInputModule} from '../shared/components/search-input/search-input.module';
import {MultiselectDropdownModule} from '../shared/components/multiselect-dropdown/multiselect-dropdown.module';
import {DialogProgressModule} from '../shared/components/dialog-progress/dialog-progress.module';
import {ButtonModule} from '../shared/components/button/button.module';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';

const routes = [
  {
    path: '', component: ConstructorComponent,
    children: [],
  },
];

@NgModule({
  declarations: [
    ConstructorComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    AlertModule,
    InputModule,
    FormsModule,
    ReactiveFormsModule,
    OptionsListModule,
    DropdownModule,
    CheckboxModule,
    BadgeModule,
    SwitcherModule,
    DialogModule,
    PinInputModule,
    MenuModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    SearchInputModule,
    MultiselectDropdownModule,
    DialogProgressModule,
    ButtonModule,
  ],
})
export class ConstructorModule {
}
